import { Modify } from '@teinor/erp'
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { ButtonPrimary } from '../../../../../../../../baseComponents/Button'
import PermissionChecker from '../../../../../../../../baseComponents/PermissionChecker'
import { ITLayoutTableModalOpenSetTy } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { RectangularInputProps, RectangularInputSmall } from '../../../../../../../../forms/Input'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useOnClickOutside from '../../../../../../../../utils/hooks/useOnClickOut'
import { getConfigParam, getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import SearchBarProductResults, { SearchBarProductResultsWithCodeBar } from '../../../../../../../Product/SearchBarProduct/SearchBarProductResults'
import { ProductExtendedTyShort } from '../../../../../../../Product/types'
import { OnChangeOrderAddProduct, OrderSearchProductFieldType, OrderSearchProductInputChangeSearchFunc } from './types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import LoadingSpinner from '../../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { ItemCustomSelectDropDownRowSection } from '../../../../../../../../forms/CustomSelect/CustomSelectSections/types'
import { faBarcode, faSquareDashedCirclePlus } from '@fortawesome/pro-light-svg-icons'
import { OnChangeSearchBarAddProduct } from '../../../../../../../Product/SearchBarProduct/types'
import { CustomSelectSectionDropDown } from '../../../../../../../../forms/CustomSelect/CustomSelectSections'

export interface OrderSearchProductInputCreateProps extends OrderSearchProductInputProps { }

export const OrderSearchProductInputCreate: React.FC<OrderSearchProductInputCreateProps> = ({ allRowData, field, setOpenModal, onChange, findFirstNameColumn }) => {
    const { searchValue, changeSearchValue, listProducts, onSelectProduct, onFocus, ref, openModalCreateProduct, loading } = useOrderSearchProductInputLogic({ field, onChange, allRowData, setOpenModal })
    if (allRowData.ProductId) {
        if (field === 'reference' && allRowData['Product.uniqueProduct']) {
            return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div>{allRowData['unique_number']}</div></DisplayProductDot>
        }
        return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div>{allRowData[field]}</div></DisplayProductDot>
    }
    if (loading) {
        return <div className='w-full'><LoadingSpinner className='w-20 h-20 mx-auto' /></div>
    }
    return (
        <div className='relative input_table_searchproductinput' ref={ref}>
            <RectangularInputSmall onChange={changeSearchValue} value={searchValue} onFocus={onFocus} />
            <SearchBarProductResultsCreate products={listProducts || []} {...{ setOpenModal: openModalCreateProduct, onSelectProduct, allRowData, field }} />
        </div>
    )
}
export type OrderSearchProductInputProps = Modify<RectangularInputProps, OrderSearchProductInputLogicProps & {
    findFirstNameColumn?: boolean
    displayField?: string
    createProductFromTPV?: boolean
}>

export const OrderSearchProductInput: React.FC<OrderSearchProductInputProps> = ({ allRowData, field, setOpenModal, onChange, findFirstNameColumn }) => {
    const { searchValue, changeSearchValue, listProducts, onSelectProduct, onFocus, ref, handleOnKeyDown, loading } = useOrderSearchProductInputLogic({ field, onChange, allRowData, setOpenModal })
    if (allRowData.ProductId) {
        if (field === 'reference' && allRowData['Product.uniqueProduct']) {
            return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData['unique_number']}</div></DisplayProductDot>
        }
        return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData[field]}</div></DisplayProductDot>
    }
    if (loading) {
        return <div className='w-full'><LoadingSpinner className='w-20 h-20 mx-auto' /></div>
    }
    return (
        <div className='relative input_table_searchproductinput' ref={ref}>
            <RectangularInputSmall onChange={changeSearchValue} onKeyDown={handleOnKeyDown} value={searchValue} onFocus={onFocus} />
            <SearchBarProductResults products={listProducts} {...{ onSelectProduct, allRowData, field }} />
        </div>
    )
}
export const OrderSearchProductInputName: React.FC<OrderSearchProductInputProps> = ({ allRowData, field, setOpenModal, onChange, findFirstNameColumn, displayField, createProductFromTPV }) => {
    const { searchValue, changeSearchValue, listProducts, onSelectProduct, onFocus, ref, handleOnKeyDown, loading } = useOrderSearchProductInputLogic({ field, onChange, allRowData, setOpenModal })
    const { t } = useTwinTranslation()
    let myField = displayField ?? field
    if (allRowData.ProductId) {
        let extraMessage = allRowData.packQuantity && parseFloat(allRowData.packQuantity) !== 1 ? (' - ' + t('pack', 'Pack') + ' ' +allRowData.packQuantity) : ''
        if (allRowData['Product.active']) {
            return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData[myField]}{extraMessage}</div></DisplayProductDot>
        }
        return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData[myField]}{extraMessage} <span className='italic'>(<TwinTrans transKey={'deleted'}>Eliminado</TwinTrans>)</span></div></DisplayProductDot>
    }
    if (loading) {
        return <div className='w-full'><LoadingSpinner className='w-20 h-20 mx-auto' /></div>
    }
    return (
        <div className='relative input_table_searchproductinput' ref={ref}>
            <RectangularInputSmall onChange={changeSearchValue} onKeyDown={handleOnKeyDown} value={searchValue} onFocus={onFocus} />
            <SearchBarProductResults products={listProducts} {...{ onSelectProduct, field }} />
            {(searchValue === '' && !listProducts?.length && !createProductFromTPV) ?
                <CustomCreateProductCustomSelectSection onSelectProduct={onSelectProduct} products={listProducts} setOpenModal={setOpenModal} />
                : <CustomCreateProductTPVCustomSelectSection onSelectProduct={onSelectProduct} products={listProducts} setOpenModal={setOpenModal} /> 
            }
        </div>
    )
}

interface CustomCreateProductCustomSelectSectionProps extends CustomCreateProductCustomSelectSectionLogicProps {
    products: ProductExtendedTyShort[] | null
}

export const CustomCreateProductCustomSelectSection: React.FC<CustomCreateProductCustomSelectSectionProps> = ({ products, onSelectProduct, setOpenModal }) => {
    const { mainProductAndComplementSections, myProductOnChange } = useCustomCreateProductCustomSelectSectionLogic({ onSelectProduct, setOpenModal })
    if (!products) {
        return null
    }
    return (
        <CustomSelectSectionDropDown items={mainProductAndComplementSections} onChange={myProductOnChange} value={''} />
    )
}

export const CustomCreateProductTPVCustomSelectSection: React.FC<CustomCreateProductCustomSelectSectionProps> = ({ products, onSelectProduct, setOpenModal }) => {
    const { mainProductSections, myProductOnChange } = useCustomCreateProductCustomSelectSectionLogic({ onSelectProduct, setOpenModal })
    const activeCreateProductFromTPV = getConfigParam('activeCreateProductFromTPV') === 'on'
    if (!products || !activeCreateProductFromTPV) {
        return null
    }
    return (
        <CustomSelectSectionDropDown items={mainProductSections} onChange={myProductOnChange} value={''} />
    )
}

interface CustomCreateProductCustomSelectSectionLogicProps {
    onSelectProduct: OnChangeSearchBarAddProduct
    setOpenModal: ITLayoutTableModalOpenSetTy
}

const useCustomCreateProductCustomSelectSectionLogic = ({ onSelectProduct, setOpenModal }: CustomCreateProductCustomSelectSectionLogicProps) => {
    const { t } = useTwinTranslation()
    const othersTrans = t('create', 'Crear')
    const mainOtherTrans = t('createProduct', 'Crear producto')
    const mainOtherTrans2 = t('createComplement', 'Crear complemento')

    const mainProductSections: ItemCustomSelectDropDownRowSection[] = useMemo(() => [{ value: "", text: othersTrans, isSection: true }, { value: -1, text: mainOtherTrans, hiddenText: mainOtherTrans, icon: faBarcode, className: 'section_items_background' }], [mainOtherTrans, othersTrans])
    const mainProductAndComplementSections: ItemCustomSelectDropDownRowSection[] = useMemo(() => [{ value: "", text: othersTrans, isSection: true }, { value: -1, text: mainOtherTrans, hiddenText: mainOtherTrans, icon: faBarcode, className: 'section_items_background' }, { value: 0, text: mainOtherTrans2, hiddenText: mainOtherTrans2, icon: faSquareDashedCirclePlus, className: 'section_items_background' }], [mainOtherTrans, othersTrans, mainOtherTrans2])

    const myProductOnSubmit = useCallback(async (product: any) => {
        onSelectProduct(product)
    }, [onSelectProduct])

    const myProductOnChange = useCallback((value: number) => {
        if (value === -1) {
            setOpenModal({ type: 'createProduct', allRowData: { onSubmit: myProductOnSubmit } })
        } else if (value === 0) {
            setOpenModal({ type: 'createComplement', allRowData: { } })
        }
    }, [setOpenModal, myProductOnSubmit])

    return { mainProductSections, mainProductAndComplementSections, myProductOnChange, setOpenModal, myProductOnSubmit }
}

export const OrderSearchProductInputReferenceAndName: React.FC<OrderSearchProductInputProps> = ({ allRowData, field, setOpenModal, onChange, findFirstNameColumn }) => {
    const { searchValue, changeSearchValue, listProducts, onSelectProduct, onFocus, ref, handleOnKeyDown, loading } = useOrderSearchProductInputLogic({ field, onChange, allRowData, setOpenModal })
    const { t } = useTwinTranslation()
    if (allRowData.ProductId) {
        let extraMessage = allRowData.packQuantity && parseFloat(allRowData.packQuantity) !== 1 ? (' - ' + t('pack', 'Pack') + ' ' +allRowData.packQuantity) : ''
        if (allRowData['Product.active']) {
            return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData.reference} - {allRowData.name}{extraMessage}</div></DisplayProductDot>
        }
        return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData.reference} - {allRowData.name}{extraMessage} <span className='italic'>(<TwinTrans transKey={'deleted'}>Eliminado</TwinTrans>)</span></div></DisplayProductDot>
    }
    if (loading) {
        return <div className='w-full'><LoadingSpinner className='w-20 h-20 mx-auto' /></div>
    }
    return (
        <div className='relative input_table_searchproductinput' ref={ref}>
            <RectangularInputSmall onChange={changeSearchValue} onKeyDown={handleOnKeyDown} value={searchValue} onFocus={onFocus} />
            <SearchBarProductResultsWithCodeBar products={listProducts} {...{ onSelectProduct, field }} />
            {(searchValue === '') ? <CustomCreateProductCustomSelectSection onSelectProduct={onSelectProduct} products={listProducts} setOpenModal={setOpenModal} /> : null}
        </div>
    )
}
interface DisplayProductDotProps {
    findFirstNameColumn?: boolean
    allRowData?: RowData
    children: React.ReactNode
}

export const DisplayProductDot: React.FC<DisplayProductDotProps> = ({ children, allRowData, findFirstNameColumn }) => {
    if (findFirstNameColumn && allRowData?.OrderProductId) {
        return (
            <div className='flex items-center'>
                <div className='pl-3 pr-10 dash_product_addon_parent'>
                    <div className='bg-gray-D9 w-8 h-8 z-1 relative rounded-full' />
                    <div className='dash_product_addon'></div>
                </div>
                {children}
            </div>
        )
    }
    return <Fragment>{children}</Fragment>
}
interface OrderSearchProductInputLogicProps {
    field: OrderSearchProductFieldType
    allRowData: RowData
    onChange: OnChangeOrderAddProduct
    setOpenModal: ITLayoutTableModalOpenSetTy
}

const useOrderSearchProductInputLogic = ({ field, onChange, allRowData, setOpenModal }: OrderSearchProductInputLogicProps) => {
    const {startLoading, endLoading, loading} = useIsLoading()
    const [listProducts, setListProducts] = useState<ProductExtendedTyShort[] | null>(null)
    const [searchValue, setSearchValue] = useState<string>('')
    const [isSearching, setIsSearching] = useState(false)
    const [isEntered, setIsEntered] = useState(false)
    const [debounceValue] = useDebounce(searchValue, 200)
    const ref = useRef<any>(null)

    const changeSearchValue: OrderSearchProductInputChangeSearchFunc = useCallback((myvalue) => {
        setIsSearching(true)
        setSearchValue(myvalue)
    }, [setSearchValue])

    const onFocus = useCallback(() => {
        setListProducts([])
    }, [])

    const onBlur = useCallback(() => {
        setSearchValue('')
        setListProducts(null)
    }, [])

    const onSelectProduct: OnChangeOrderAddProduct = useCallback((product) => {
        startLoading()
        if (product.isVariantProduct && !product.ProductId) {
            setOpenModal({ type: 'complexProduct', allRowData: { ...product, ProductId: product.id } })
            onBlur()
            endLoading()
        } else {
            onChange({ ...product })
            endLoading()
        }
    }, [onChange, setOpenModal, onBlur, startLoading, endLoading])

    const handleOnKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            if (!isSearching) {
                if (listProducts && listProducts.length) {
                    onSelectProduct(listProducts[0])
                }
            } else {
                setIsEntered(true)
            }
        }
    }, [onSelectProduct, listProducts, isSearching])

    const openModalCreateProduct = useCallback(() => {
        onBlur()
        setOpenModal({ type: 'createProduct', allRowData })
    }, [onBlur, setOpenModal, allRowData])

    useOnClickOutside(ref, onBlur)

    const getAllProducts = useCallback(async (mySearchValue: string) => {
        setIsSearching(true)
        const extraWhere: TwinDictionary = {}
        const myiLike = {
            $iLike: '%' + mySearchValue + '%',
        }
        if (field === 'referenceAndName') {
            extraWhere['$or'] = [
                {
                    '$or': [
                        { name: myiLike },
                        { reference: myiLike },
                        { code_bar: myiLike },
                    ],
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$is': null
                    }
                },
                {
                    unique_number: mySearchValue,
                    uniqueProduct: true
                },
                {
                    '$or': [
                        { name: mySearchValue },
                        { reference: mySearchValue },
                        { code_bar: mySearchValue },
                    ],
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$not': null
                    }
                },
            ]
        } else {
            extraWhere['$or'] = [
                {
                    [field]: myiLike,
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$is': null
                    }
                },
                {
                    unique_number: mySearchValue,
                    uniqueProduct: true
                },
                {
                    [field]: mySearchValue,
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$not': null
                    }
                },
            ]
        }
        const result = await twinFetchPostJSON('/api/app/product/getAllProductsForOrder', {
            where: {
                productType: {
                    $notIn: [5]
                },
                ...extraWhere
            },
            limit: 15
        })
        setListProducts(result)
        if (isEntered && result && result.length) {
            onSelectProduct(result[0])
        }
        setIsSearching(false)
        setIsEntered(false)
    }, [field, setIsSearching, isEntered, onSelectProduct])

    useEffect(() => {
        if (debounceValue !== '') {
            getAllProducts(debounceValue)
        } else if (debounceValue === '') {
            setListProducts((old) => {
                if (old) {
                    return []
                }
                return null
            })
        }
    }, [debounceValue, getAllProducts])

    return { searchValue, changeSearchValue, listProducts, onSelectProduct, onFocus, ref, openModalCreateProduct, handleOnKeyDown, loading }
}

interface SearchBarProductResultsCreateProps {
    products: ProductExtendedTyShort[] | null
    onSelectProduct: OnChangeOrderAddProduct
    setOpenModal: () => void
    allRowData: RowData
}

const SearchBarProductResultsCreate: React.FC<SearchBarProductResultsCreateProps> = ({ products, setOpenModal, onSelectProduct }) => {
    const renderThis: JSX.Element[] = []
    if (!products) {
        return null
    }
    for (const key in products) {
        const product = products[key]
        renderThis.push(<SearchedProductV key={key} product={product} onSelectProduct={onSelectProduct} />)
    }
    return (
        <div className='searched_input_products'>
            <div className='results_searched_products'>
                {renderThis}
            </div>
            <PermissionChecker userPermissions={getUserPermissions('product.profile.main')} permission={'create'}>
                <div className='flex items-center justify-center my-8 px-10' key={0}>
                    <ButtonPrimary className='w-full' onClick={setOpenModal}>
                        <TwinTrans transKey={'createProduct'}>Crear producto</TwinTrans>
                    </ButtonPrimary>
                </div>
            </PermissionChecker>
        </div>
    )
}


interface SearchedProductProps {
    onSelectProduct: OnChangeOrderAddProduct
    product: ProductExtendedTyShort
}

const SearchedProductV: React.FC<SearchedProductProps> = ({ product, onSelectProduct }) => {
    const productName = product['ProductLangs.name']
    const reference = product.reference
    const productImg = product['ProductImages.url']
    let fields: TwinDictionary = {
        main: productName,
        secondary: reference,
    }
    return (
        <div className='searched_product' onClick={() => onSelectProduct(product)}>
            <img src={productImg || '/no-image-small.png'} alt={fields.name} className='related_product_img' />
            <span className='text-green-00 font-medium min-w-31'>{fields.secondary}</span>
            <span className='mx-5 text-green-00'>-</span>
            <span>{fields.main}</span>
        </div>
    )
}

export default OrderSearchProductInput